export enum Experiment {
  EnableEarnPointsLimits = 'enableEarnPointsLimits',
  PointsAdjustmentEnabled = 'pointsAdjustmentEnabled',
}
